export class ChangeableSubject<T> {
    private _value: T;
    private onChanges: ((value: T) => void)[] = [];
    public isInited = false;
    public isIniting = false;

    constructor(value: T) {
        this._value = value;
    }

    public get value(): T {
        return this._value;
    }

    public set value(v: T) {
        this._value = v;

        for (const oc of this.onChanges) {
            oc(v);
        }
    }

    public onChange(onChange: (value: T) => void, fireImmediately = false) {
        this.onChanges.push(onChange);

        if (fireImmediately) {
            onChange(this._value);
        }
    }

    public offChange(onChange: (value: T) => void) {
        const index = this.onChanges.indexOf(onChange);
        if (index !== -1) {
            this.onChanges.splice(index, 1);
        }
    }
}

export interface Resp<D> {
    status: number;
    data: D
}

export interface PageData<D> {
    items: D[],
    pages: number,
    number: number
    size: number
    total: number
}

export interface DataFile {
    id: number,
    name: string,
    container_type: number,
    container_id: number,
    deleted?: boolean
    url?: string;
}

export enum FileContainerType {
    FailReportPhoto = 1,
    CommentPhoto = 2,
    RMARootCause = 3,
    WaiveUnitPicture = 4,
    TestingSummaryFile = 5,
    EquipmentFile = 6,
    EquipmentChangeFile = 7,
    EquipmentCalibrationFile = 8
}


export const PlotChannelColors = ['rgb(73,98,153)', '#D05753', 'rgb(220, 192, 6)']
export const PlotChannelDeepColors = ['rgb(28,59,128)', 'rgb(198,77,73)', 'rgb(227, 199, 18)']

export const AREAS: { [value: number]: string } = {
    0: 'China',
    1: 'USA',
    2: 'Vienna'
}

export interface RoomUncertaintyData {
    id: number,
    name: string
}

export interface FixedXValuesData {
    id: number,
    name: string
}

export interface JournalizationDetailField {
    key: string;
    name: string;
    isList?: boolean | ((jd: any) => boolean);
    formater?: (v: any) => string | Promise<string>;
    childrenKeyFormatter?: (v: any) => string;

    children?: JournalizationDetailField[]
}

export const ENUM_TYPES_EQUIPMENT_TYPE = 1;
export const ENUM_TYPES_EQUIPMENT_DEVICE = 2;
export const ENUM_TYPES_EQUIPMENT_BRAND = 3;
export const ENUM_TYPES_EQUIPMENT_LOCATION = 4;
export const ENUM_TYPES_EQUIPMENT_PRODUCT = 5;
export const ENUM_TYPES_EQUIPMENT_STORAGE_PLACE = 6;
export const ENUM_TYPES_EQUIPMENT_TEAM = 7;
export const ENUM_TYPES_EQUIPMENT_MODEL = 8;
export const ENUM_TYPES_EQUIPMENT_PART = 11;
export const ENUM_TYPES_EQUIPMENT_PROJECT_USED_FOR = 10;
export const ENUM_TYPES_ISSUE_OVERVIEW_ROOT_CAUSE = 9;


export interface CommonPermission {
    view: string
    create: string
    update: string
    delete: string
}


export interface EnumConfig {
    permissions: CommonPermission
}


export interface LewittProduct {
    name: string;
    used_count: number;
}

export const ORDERS_NEED_COUNTER = ['TP', 'PP', 'RD']


export type Override<T, U> = Omit<T, keyof U> & U;

export type Translate = (text: string | string[], skipIndexes?: number[]) => string
export type LANG = 'cn' | 'en'